export const GET_SYSTEM_MANUFACTURER = 'GET_SYSTEM_MANUFACTURER';
export const SYSTEM_MANUFACTURER_UPDATED = 'SYSTEM_MANUFACTURER_UPDATED';